import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import "./i18n";

import React from "react";

import { BrowserRouter } from "react-router-dom";
import App from "App";


import { Provider as ReduxProvider } from "react-redux";
import thunk from "redux-thunk";
import reducer from "./reducers";
import ReactDOM from 'react-dom/client';
import MuiSnackbar from "./components/MDSnackbar";
const container = document.getElementById("app");
const root = ReactDOM.createRoot(container);

const reduxStore = createStore(
  reducer, {},

  composeWithDevTools(
    applyMiddleware(thunk)
  )
);

root.render(
  <BrowserRouter>
    <ReduxProvider store={reduxStore}>
      {/*<MaterialUIControllerProvider>*/}
      {/*  <DevSupport ComponentPreviews={ComponentPreviews}*/}
      {/*              useInitialHook={useInitial}*/}
      {/*  >*/}
            <App />
            <MuiSnackbar/>

        {/*</DevSupport>*/}
      {/*</MaterialUIControllerProvider>*/}
    </ReduxProvider>
  </BrowserRouter>
);
